import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async addAorToProject(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.patch(`/projects-administration/${data.project_id}/aor`, data.aor, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
